import { create } from 'zustand'
import { AUTH_PROVIDERS } from '../constants'

type AuthProviderKeys = keyof typeof AUTH_PROVIDERS

interface ExtenalLoginState {
  provider: (typeof AUTH_PROVIDERS)[AuthProviderKeys] | null
  setAuthProvider: (provider: (typeof AUTH_PROVIDERS)[AuthProviderKeys]) => void
  resetLoginStore: () => void
}

export const useExtenalLoginStore = create<ExtenalLoginState>()(set => ({
  provider: null,
  setAuthProvider: provider => {
    set({ provider })
  },

  resetLoginStore: () => {
    set({
      provider: null,
    })
  },
}))
